import { Component } from '@angular/core';
import { HaylieService } from '../../core/services/haylie.service';
import { eClass } from '../../core/services/entities';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { MasterService } from '../../core/services/master.service';

@Component({
  selector: 'app-agenda.component',
  imports: [FontAwesomeModule],
  templateUrl: './agenda.component.html',
  styleUrl: './agenda.component.scss',
})
export class AgendaComponent {
  faArrow = faArrowRight;
  faWhatsapp=faWhatsapp;

  model_classes : eClass[] = [];
  model_base_days: string[] = ["segunda", "terça", "quarta", "quinta", "sexta", "sábado", "domingo"];
  model_base_skills: string[] = ["jiu", "thay", "boxe"];
  model_search_skill = '';
  model_search_day = '';

  constructor(
    private haylie: HaylieService,
    private _svc_master: MasterService,
    //private morgana: MorganaService,
    
  ) { }

  ngOnInit(): void {
    this.model_search_skill = '';
    this.model_search_day = '';
    this.model_search_skill = 'jiu';
    //this.model_search_day = this.morgana.getdayofweek(new Date().getUTCDay().toString());
  
    //this.haylie.get_classes("").then(this.catch_classes);
  }

  navigate(p_to:string): void {
    this._svc_master.navigate(p_to); 
    
  }

  private catch_classes = (p_response: any) =>  {
    var l_response = JSON.parse(p_response);
    this.model_classes = [];
    this.model_classes = l_response.classes;
    
    return this.model_classes;
  }
  filterClasses(p_skill:string, p_day:string): any[] {
    let result : eClass[] = [];  
    
    if (p_skill.length > 0)
      return this.model_classes.filter(x => x.skill === p_skill && x.day === this.model_search_day);
    else 
      return this.model_classes.filter(x => x.day === this.model_search_day);
    
  
  }
  select_change(p_select:string, p_val:string):void {
    switch (p_select) { 
      case "search": this.model_search_skill = p_val; break;
      case "searchday": 
        this.model_search_day = p_val; 
        console.log('p_val> ' + p_val);
        console.log('model_search_day> ' + this.model_search_day);
        break;
    }
    //this.frmskill.focus();
  }

}
